export class PhoneNumberDeformatter {
  get(phoneNumber: string): string {
    return phoneNumber.replace(/[^\d+]+/gi, '');
  }
}
